/**
 * Creating this file to solve Row's style not found
 * when Row is exported from 'antd' directly in index.js
 */
import { Row } from 'antd';
export default Row;